<fr8bot-web-header />
<router-outlet />
<fr8bot-web-footer />
